import { NgModule } from '@angular/core';

import { InspectionEmailComponent } from './inspection.email.component';
import { SharedModule }             from '../shared/shared.module';

@NgModule({
  declarations: [
    InspectionEmailComponent
  ],
  entryComponents: [
    InspectionEmailComponent
  ],
  imports: [
    SharedModule
  ]
})
export class InspectionsModule {}
